export const T2I2V_MODEL_OPTIONS = ['v2.5.1', 'v3.0', 'v3.0.2'] as const
export type T2I2VModel = (typeof T2I2V_MODEL_OPTIONS)[number]

export const T2I2V_DEFAULT_MODEL = 'v3.0.2' satisfies T2I2VModel
